import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { menuItem } from "../app/schema";

export const PATCH_MENU_ITEM = "PATCH_MENU_ITEM";
export const PATCH_MENU_ITEM_SUCCESS = "PATCH_MENU_ITEM_SUCCESS";
export const PATCH_MENU_ITEM_ERROR = "PATCH_MENU_ITEM_ERROR";

export const DELETE_MENU_ITEM = "DELETE_MENU_ITEM";
export const DELETE_MENU_ITEM_SUCCESS = "DELETE_MENU_ITEM_SUCCESS";
export const DELETE_MENU_ITEM_ERROR = "DELETE_MENU_ITEM_ERROR";

export const SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE = "SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE";
export const SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE = "SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE";
export const SET_IS_ADD_MENU_ITEM_MODAL_VISIBLE = "SET_IS_ADD_MENU_ITEM_MODAL_VISIBLE";

// Requests

const patchMenuItem = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/menu-items/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteMenuItem = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/menu-items/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych elementu menu, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function updateMenuItem(data, uid) {
  if (data.fieldType === "rawURL") {
    if (
      data.value.substring(0, 7) !== "http://" &&
      data.value.substring(0, 8) !== "https://"
    ) {
      data.value = `http:\/\/${data.value}`;
    }
  }
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_MENU_ITEM],
    payload: {
      promise: patchMenuItem(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, menuItem);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeMenuItem(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_MENU_ITEM],
    payload: {
      promise: deleteMenuItem(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveMenuItemModalVisible(value) {
  return {
    type: SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE,
    payload: {
      value
    }
  };
}

export function setIsEditMenuItemModalVisible(value) {
  return {
    type: SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE,
    payload: {
      value
    }
  };
}

export function setIsAddMenuItemModalVisible(value) {
  return {
    type: SET_IS_ADD_MENU_ITEM_MODAL_VISIBLE,
    payload: {
      value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/menuItems/actions.js